import React, { Component } from "react";
export default class Loading extends Component {
  componentDidMount() {
    window.location.href = "/login";
  }
  render() {
    return <div></div>;
  }
}
